import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type CertidaoCancelamentoPjJob = ReportJob;
export type CertidaoCancelamentoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Cancelamento PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoCancelamentoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-cancelamento-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certidaoCancelamentoPj;
}
